class I18n {
	constructor({
		id = '',
		tableName = '',
		tableId = '',
		menuId = '',
		isoLanguageCode = '',
		title = '',
		value = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.tableName = tableName === null ? '' : tableName
		this.tableId = tableId === null ? '' : tableId
		this.menuId = menuId === null ? '' : menuId
		this.isoLanguageCode = isoLanguageCode === null ? '' : isoLanguageCode
		this.title = title === null ? '' : title
		this.value = value === null ? '' : value
	}
	id: string
	tableName: string
	tableId: string
	menuId: string
	isoLanguageCode: string
	title: string
	value: string
}

export { I18n }
